module.exports = __webpack_public_path__ + "img/series_11.d9fd8d1f.png";